const errorMap = {
  ContentExample1ParsingError: {
    label: 'Example Parsing Issue',
    details: 'Content of Example 1 was not retrieved'
  },
  ContentExample2ParsingError: {
    label: 'Example Parsing Issue',
    details: 'Content of Example 2 was not retrieved'
  },
  VehicleCatalogError: {
    label: 'Vehicle Catalog Issue',
    details: 'Vehicle Catalog information was not retrieved'
  },
  ThrottlingException: {
    label: 'Throttling Exception',
    details: 'Content not generated due to Bedrock execution issue'
  },
  ServiceUnavailable: {
    label: 'Service Unavailable',
    details: 'Content not generated due to Bedrock execution issue'
  },
  InternalFailure: {
    label: 'Internal Failure',
    details: 'Content not generated due to Bedrock execution issue'
  },
  ContentRequestUpdateError: {
    label: 'Generation content out of date',
    details:
      'The request cannot be processed because the generation content is likely out of date. Try getting the latest content by selecting it from the generation content history browser'
  },
  ClipboardFormInitializationError: {
    label: 'Invalid clipboard data',
    details:
      'The form cannot be initialized using existing clipboard data. The data must be a valid JSON.'
  },
  NetworkError: {
    label: 'Network Failure',
    details:
      'The client cannot connect to the backend application. Backend services may be down. Please wait a while and try again.'
  }
};

export const mapError = (name, message) => {
  return (
    errorMap[name] ?? {
      label: 'An error occurred',
      details: message
    }
  );
};

export const extractError = (response) => {
  const { error, output } = response;

  if (!error) {
    return null;
  }

  return mapError(error, output);
};
